// extracted by mini-css-extract-plugin
export default {"hamburger":"lsf-hamburger","hamburger_animated":"lsf-hamburger_animated","hamburger_opened":"lsf-hamburger_opened"};